import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_ioredis@5.6.0_magicast@0.3.5__ixm45pg5mktiblilsdif6d2ksi/node_modules/nuxt/dist/pages/runtime/validate.js";
import token_45global from "/app/middleware/token.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_ioredis@5.6.0_magicast@0.3.5__ixm45pg5mktiblilsdif6d2ksi/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  token_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_magicast@0.3.5_next-auth@4.24.11_next@15.2.4_@babel+core@7.26.10_r_6ufdno6exjavqru3odmt76lh5u/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}